// Default list of link token param fields to be masked in log metadata.
// Add fields to this list as needed.
export default ['account_number', 'routing_number'];
